import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Signup from './parts/Signup';

function AdminAdd() {
  return (
    <Container fluid className="h-100 mt-4">
      <Row>
        <Col>
          <h3>管理者登録</h3>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <Signup admin={true} />
        </Col>
      </Row>
    </Container>
  );
}

export default AdminAdd;
